import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/services/auth.service';
import { ChatService } from 'src/app/services/chat.service';
import { EventService } from 'src/app/services/event.service';

@Component({
  selector: 'app-manage-data',
  templateUrl: './manage-data.component.html',
  styleUrls: ['./manage-data.component.css'],
})
export class ManageDataComponent implements OnInit {
  submited: boolean = false;
  isDisabled: boolean = false;
  manageDataForm!: FormGroup;
  codeDeletedForm!: FormGroup;
  selectData: any = [
    {
      id: "1",
      label: 't-get-informations',
    },
    {
      id: "2",
      label: 't-delete-account',
    },
  ];
  emailCode: any;
  sendDeleted: boolean = false;
  showDeletedMessage: boolean = false;
  showDataMessage: boolean = false;

  constructor(
    private eventService: EventService,
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private translateService: TranslateService,
    private chatService: ChatService
  ) { }

  ngOnInit(): void {
    this.eventService.broadcast('header-page-title', 'MANAGE-DATA.TEXT');
    this.manageDataForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      type: ["1", [Validators.required]],
      code: [''],
    });
  }

  get form() {
    return this.manageDataForm.controls;
  }

  get formDelete() {
    return this.codeDeletedForm.controls;
  }

  submitForm() {
    this.submited = true;
    if (this.manageDataForm.invalid) {
      return;
    } else {
      this.isDisabled = true;
      if (this.form['type'].value == 1) {
        this.authService.sendAccountInfo(this.form['email'].value).subscribe({
          next: () => {
            this.isDisabled = false;
            this.submited = false;
            this.showDataMessage = true;
            setTimeout(() => {
              this.showDataMessage = false;
            }, 5000);
          },
          error: (err: any) => {
            this.isDisabled = false;
            this.submited = false;
            this.form['email'].setErrors({
              noData: true,
            });
          },
        });
      } else {
        const user = this.authService.currentUserValue;
        if (user && user.email == this.form['email'].value) {
          this.authService.sendCodeToDelete(this.form['email'].value).subscribe({
            next: (data: any) => {
              this.codeDeletedForm = this.formBuilder.group({
                code: ['', [Validators.required]],
              });
              this.submited = false;
              this.sendDeleted = true;
              this.isDisabled = false;
            },
            error: (err: any) => {
              this.isDisabled = false;
            },
          });
        } else {
          this.form['email'].setErrors({
            noData: true,
          });
          this.isDisabled = false;
        }
      }
    }
  }

  submitDelete() {
    this.submited = true;
    if (this.manageDataForm.invalid) {
      return;
    } else {
      this.isDisabled = true;
      const user = this.authService.currentUserValue;
      if (user) {
        this.authService
          .deleteAccount(user.email, this.formDelete['code'].value)
          .subscribe({
            next: (data: any) => {
              this.isDisabled = false;
              this.showDeletedMessage = true;
              this.authService.removeUserToLocalStorage();
              this.chatService.closeConnection();
              setTimeout(() => {
                this.router.navigate(['/']);
              }, 500);
            },
            error: (err: any) => {
              console.log(err);
              if (err?.error?.message == 'wrongCode') {
                this.isDisabled = false;
                this.formDelete['code'].setErrors({
                  wrongCode: true,
                });
              } else {
                this.isDisabled = false;
                this.formDelete['code'].setErrors({
                  noData: true,
                });
              }
            },
          });
      }
    }
  }
}
